import { useEffect, useState } from "react";

import { InterventionChecklistsModal, InterventionChecklistsTable } from "modules/PendingChecklistsDashboard/components/InterventionChecklists/components";

import type { Checklist } from "models";
import type { InterventionPendingChecklistsGrouped } from "modules/PendingChecklistsDashboard/components/InterventionChecklists/hooks";

type InterventionChecklistsProps = {
  isInterventionPendingChecklistsLoading: boolean;
  checklists?: Checklist[];
  interventionPendingChecklistsGrouped?: InterventionPendingChecklistsGrouped[];
};

export const InterventionChecklists = ({ isInterventionPendingChecklistsLoading, checklists, interventionPendingChecklistsGrouped }: InterventionChecklistsProps) => {
  const [selectedInterventionKeyword, setSelectedInterventionKeyword] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!selectedInterventionKeyword || !interventionPendingChecklistsGrouped) return;

    if (interventionPendingChecklistsGrouped.every(ipc => ipc.keyword !== selectedInterventionKeyword)) setSelectedInterventionKeyword(undefined);
  }, [interventionPendingChecklistsGrouped, selectedInterventionKeyword]);

  return (
    <>
      <InterventionChecklistsTable
        isLoading={isInterventionPendingChecklistsLoading}
        pendingChecklistsGrouped={interventionPendingChecklistsGrouped}
        onOpenCreateEditInterventionChecklistsModal={(keyword: string | null) => setSelectedInterventionKeyword(keyword)}
      />
      <InterventionChecklistsModal
        checklists={checklists}
        selectedInterventionKeyword={selectedInterventionKeyword}
        interventionPendingChecklistsGrouped={interventionPendingChecklistsGrouped}
        onSetSelectedInterventionKeyword={(keyword: string) => setSelectedInterventionKeyword(keyword)}
        onClose={() => setSelectedInterventionKeyword(undefined)}
      />
    </>
  );
};
